"use strict";

exports.__esModule = true;
exports.default = getBreakpoints;

var _ssrWindow = require("ssr-window");

function getBreakpoints(breakpoints) {
  var window = (0, _ssrWindow.getWindow)(); // Get breakpoint for window width

  if (!breakpoints) return undefined;
  var breakpoint = false;
  var points = Object.keys(breakpoints).map(function (point) {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = window.innerHeight * minRatio;
      return {
        value: value,
        point: point
      };
    }

    return {
      value: point,
      point: point
    };
  });
  points.sort(function (a, b) {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });

  for (var i = 0; i < points.length; i += 1) {
    var _points$i = points[i],
        point = _points$i.point,
        value = _points$i.value;

    if (value <= window.innerWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/cjs/components/core/breakpoints/getBreakpoint.js
// module id = 98
// module chunks = 0